export class UIFeedback {
  id: string | undefined;
  isHelpful: string | undefined;
  thoughts: string | undefined;
  featureName: string | undefined;

  constructor(feedback: Partial<UIFeedback>) {
    this.id = feedback.id;
    this.featureName = feedback.featureName;
    this.isHelpful = feedback.isHelpful;
    this.thoughts = feedback.thoughts;
  }
}
